module.exports = __webpack_public_path__ + "img/facebook.82e10513.svg";